/*
Author: Chathuraka Mallawa Arachchi
Date: 18/10/2024
Copyright © 2024 Infix!. All rights reserved.

Responsible for form applying validations based on question type
*/

import { DateRangeType } from '../types/commonTypes'
import { INode } from '../types/nodeTypes'

const dateRangeTypes = (function () {
    // const applyValuesToFormObject = (form :FormState, questionnaireDetails, answer )=>{

    //     const validatedForm = ValidationManager.applyCommonValidations(element)
    // }
    //[Date | null, Date | null]
    const generateDateRangeType = (answer: DateRangeType, index: number) => {
        const datRange: INode = {
            title: 'Please enter all the dates you are unavailable.',
            type: 'DateRangeMatrix',
            parent: 'smokingType',
            name: `UnavailableDatesPatient${index}`,
            value: answer,
            validations: [
                {
                    type: 'required',
                    message: 'Please select an option',
                },
            ],
        }

        // const years: INode = {
        //     title: 'Years',
        //     type: 'number',
        //     prevNode: '',
        //     parent: 'smokingType',
        //     nextNode: '',
        //     validation: {
        //         rules: {
        //             numeric: { message: 'The value should be a valid number' },
        //         },
        //     },
        //     name: `HealthImprovement${answer.type}years`,
        //     value: answer.years,
        // }
        const nodes: INode = datRange
        //nodes.push(datRange)
        return nodes
    }

    return {
        // applyValuesToFormObject,
        generateDateRangeType,
    }
})()

export default dateRangeTypes
